import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import axios from 'axios'
import VueI18n from "vue-i18n";
import zh from "./../assets/lang/zh.js";
import en from "./../assets/lang/en.js";
import { Loading } from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';

Vue.config.productionTip = false
Vue.prototype.$http = axios
Vue.prototype.$retTime = retTime;
Vue.use(VueI18n);
Vue.use(Loading);


function retTime(time) { //时间
  var date = new Date(time);
  var y = date.getFullYear(),
  m = date.getMonth()+1,
  m =(m<10 ? "0"+m:m), 
  d = date.getDate(),
  d = (d<10 ? "0"+d:d),
  H = date.getHours(),
  H = (H<10 ? "0"+H:H),
  M = date.getMinutes(),
  M = (M<10 ? "0"+M:M),
  S = date.getSeconds(),
  S = (S<10 ? "0"+S:S);

  return y+"-"+m+"-"+d+" "+H+":"+M+":"+S;
}

// 语言切换
// var language = localStorage.getItem("language");
// if(!language){
//   let type = navigator.appName;
//   if(type == "Netscape"){
//     var lang = navigator.language;
//   }else{
//     var lang = navigator.userLanguage;
//   }
//   lang = lang.substr(0,2);
//   if(lang == "zh"){
//     language="zh"
//   }else{
//     language="en"
//   }
// }

var language = 'en';

const i18n = new VueI18n({
  locale: language,
  messages: {
    "zh": zh,
    "en": en
  }
});

new Vue({
  i18n,
  router,
  store,
  render: h => h(App)
}).$mount('#app')
